export class DomainConfigModel {
    currency: any;
    api_url: any;
    siteId: any;
}